import type {LayoutPayload} from '@github-ui/code-view-types'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {SplitPageLayout} from '@primer/react'

import {OverviewHeader} from '../components/overview/OverviewHeader'
import {SharedPageLayout} from '../components/SharedPageLayout'
import {Nothing} from '../components/states/empty/Nothing'
import {OnboardingPrompts} from '../components/states/empty/OnboardingPrompts'
import {QuickSetupBox} from '../components/states/empty/QuickSetupBox'
import {codeViewLayoutRoute} from '../routes/code-view-layout-route'

export function CodeViewEmptyLayout({data}: {data: LayoutPayload}) {
  const {repo} = data
  // TODO: show the global site footer on the empty repo state. The parent
  // `_codeview_layout` route in ui-service sets `staticData: {hideFooter: true}`
  // (see packages/ui-service/src/routes/code-view/layout.tsx), and that's
  // resolved statically across all matches in GlobalNavLayout — so there's no
  // per-render way to opt back in from here today. Needs either a runtime
  // override (e.g. a context the nav layout reads) or restructuring of the
  // route's static data before the footer can render on this page.
  const {data: sidebarAbout, queryKey: sidebarAboutQueryKey} = useRouteQuery(codeViewLayoutRoute, 'sidebarAbout')

  return (
    <SharedPageLayout narrow={false}>
      <SplitPageLayout className="container-xl">
        <SplitPageLayout.Header padding="none" divider="none" className="tmp-px-3">
          <OverviewHeader overview={{}} headerData={{aboutData: sidebarAbout, queryKey: sidebarAboutQueryKey}} />
        </SplitPageLayout.Header>
        <SplitPageLayout.Content as="div" padding="condensed" width="xlarge">
          <OnboardingPrompts repo={repo} />
          {repo.currentUserCanPush ? <QuickSetupBox repo={repo} /> : <Nothing />}
        </SplitPageLayout.Content>
      </SplitPageLayout>
    </SharedPageLayout>
  )
}
